// extracted by mini-css-extract-plugin
module.exports = {"link":"link--1ZXVJ","body":"body--2_CK8","wrap":"wrap--1XcM3","title":"title--3tDj5","inputLabel":"inputLabel--3ix1G","input":"input--32V9M","btn":"btn--31GPm"};